
import { Base } from '../base-component';

import './promotional-banner-item.component.scss';

export class PromotionalBannerItem extends Base {

	constructor(element: Element){
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/promotional-banner-item/promotional-banner-item.component.ts